// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1X0lL","approved":"Status_approved__2BRlW","rejected":"Status_rejected__3q3rw","expired":"Status_expired__1aNjE","label":"Status_label__wcSim"};